import { HStack, IconButton, Tooltip } from '@elkaso-app/web-design';
import { ICrmMasterCuisineData } from 'apis/crm-master-cuisines';
import React, { useCallback } from 'react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';

export interface IActionsCell {
  masterCuisine: ICrmMasterCuisineData;
  onEdit: (masterCuisine: ICrmMasterCuisineData) => void;
  onDelete: (masterCuisine: ICrmMasterCuisineData) => void;
}

export const ActionsCell: React.FC<IActionsCell> = ({ masterCuisine, onEdit, onDelete }) => {
  const handleEdit = useCallback(() => {
    onEdit(masterCuisine);
  }, [onEdit, masterCuisine]);

  const handleDelete = useCallback(() => {
    onDelete(masterCuisine);
  }, [onDelete, masterCuisine]);

  return (
    <HStack spacing={1}>
      <Tooltip label='Edit Master Cuisine' placement='top'>
        <IconButton
          aria-label='Edit master cuisine'
          icon={<FiEdit2 />}
          size='sm'
          variant='ghost'
          colorScheme='blue'
          onClick={handleEdit}
        />
      </Tooltip>
      <Tooltip label='Delete Master Cuisine' placement='top'>
        <IconButton
          aria-label='Delete master cuisine'
          icon={<FiTrash2 />}
          size='sm'
          variant='ghost'
          colorScheme='red'
          onClick={handleDelete}
        />
      </Tooltip>
    </HStack>
  );
};
